import angular from "angular";
import controller from "./instructor-rto-day.controller";
import template from "./instructor-rto-day.html";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.instructors.view.timeoffrequests.create.day",
    {
      url: "/day",
      controller: controller,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.owner,
          USER_ROLES.instructor,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.view.timeoffrequests.create.day", [])
  .config(config)
  .controller("InstructorRequestTimeOffDayController", controller);
